export function splitPanelStyle(index: number, count: number, skew = 18): React.CSSProperties {
  const halfSkew = skew / 2
  const sliceWidth = 100 / count

  const nominalLeft = index * sliceWidth
  const nominalRight = (index + 1) * sliceWidth
  const panelLeft = Math.max(0, nominalLeft - halfSkew)
  const panelRight = Math.min(100, nominalRight + halfSkew)
  const panelWidth = panelRight - panelLeft

  const toLocal = (cardPct: number) => ((cardPct - panelLeft) / panelWidth) * 100
  const leftTop = index === 0 ? 0 : toLocal(nominalLeft + halfSkew)
  const rightTop = index === count - 1 ? 100 : toLocal(nominalRight + halfSkew)
  const leftBottom = index === 0 ? 0 : toLocal(nominalLeft - halfSkew)
  const rightBottom = index === count - 1 ? 100 : toLocal(nominalRight - halfSkew)

  return {
    left: `${panelLeft}%`,
    width: `${panelWidth}%`,
    clipPath: `polygon(${leftTop}% 0%, ${rightTop}% 0%, ${rightBottom}% 100%, ${leftBottom}% 100%)`,
  }
}
